import { useEffect, useState } from "react";
import useCeo from "../../hooks/useCEO";
import { useUnidades } from "../../hooks/test/useUnidades";
import Swal from "sweetalert2";
import Select from "react-select";
import { TituloUnidadesConteo } from "../../components/customFunctionalComponents/components/TituloUnidadesConteo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { SinUnidades } from "../../components/customFunctionalComponents/components/SinUnidades";
import Paginacion from "../../components/customComponents/Paginacion";
import mdvr from "../../assets/img/mdvr.png";
import { ModalFormRight } from "../../components/customComponents/Modals/ModalFormRight";
import * as bootstrap from "bootstrap";
import { Offcanvas } from "bootstrap";

export const AdministracionMdvrs = () => {
    useCeo({
        title: "Administración de MDVRS",
        description: "Página de gestión de MDVRS",
    });

    const initialStateForm = {
        estatus_equipo: "",
        fecha_revicion: "",
        camara1: "",
        camara2: "",
        camara3: "",
        camara4: "",
        gps: false,
        grabacion: false,
        imagen: null,
        observaciones: "",
    };

    const {
        getMdvrsClientes,
        getMdvrsDispositivos,
        getStatusCamaras,
        getInfoMdvr,
        postCheckListMdvr,
        postImagenMdvr
    } = useUnidades();

    const [clientesMdvrs, setClientesMdvrs] = useState([]);
    const [dispositivosMdvrs, setDispositivosMdvrs] = useState([]);
    const [cliente, setCliente] = useState("");
    const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
    const [palabra, setPalabra] = useState("");
    const [paginado, setPaginado] = useState([]);
    const [mdvrSeleccionado, setMdvrSeleccionado] = useState(null);
    const [statusCamaras, setStatusCamaras] = useState([]);
    const [infoMdvrSeleccionado, setInfoMdvrSeleccionado] = useState(null);
    const [loadingMdvr, setLoadingMdvr] = useState(false);
    const [form, setForm] = useState(initialStateForm);
    const MAX_SIZE = 8 * 1024 * 1024; // 5MB
    const TIPOS_PERMITIDOS = [
        "image/jpg",
        "image/png",
        "image/gif",
        "image/jpge",
        "image/bmp",
        "image/tiff",
        "image/jpeg",
    ];

    useEffect(() => {
        loadInfo();
    }, []);

    useEffect(() => {
        const delay = setTimeout(() => {
            buscarDispositivos(1);
        }, 500);

        return () => clearTimeout(delay);
    }, [palabra, cliente]);

    useEffect(() => {
        if (form.estatus_equipo !== "encendido") {
            setForm(prev => ({
                ...prev,
                fecha_revicion: "",
                camara1: "",
                camara2: "",
                camara3: "",
                camara4: "",
                gps: false,
                grabacion: false,
                imagen: null,
                observaciones: "",
            }));
        }
    }, [form.estatus_equipo]);


    const loadInfo = async () => {
        let resp = await getMdvrsClientes();

        if (resp.ok) {
            setClientesMdvrs(resp.catalogo);
        } else {
            Swal.fire({
                title: resp.msg,
                icon: "info",
                timer: 2500,
                showConfirmButton: false,
            });
        }

        let unidades = await getMdvrsDispositivos();
        if (unidades.ok) {
            setDispositivosMdvrs(unidades?.data);
            setPaginado({
                page: unidades?.data?.paginacion?.pagina,
                limit: unidades?.data?.paginacion?.totalRegistros,
                previousPage: unidades?.data?.paginacion?.previousPage,
                nextPage: unidades?.data?.paginacion?.nextPage,
                total: unidades?.data?.paginacion?.totalRegistros,
                totalPaginas: unidades?.data?.paginacion?.totalPaginas,
            });
        } else {
            Swal.fire({
                title: unidades.msg,
                icon: "info",
                timer: 2500,
                showConfirmButton: false,
            });
        }

        let catStatusCamaras = await getStatusCamaras();

        if (catStatusCamaras.ok) {
            setStatusCamaras(catStatusCamaras.data);
        } else {
            Swal.fire({
                title: catStatusCamaras.msg,
                icon: "info",
                timer: 2500,
                showConfirmButton: false,
            });
        }
    }

    // Manejar el cambio de página
    const handlePageChange = async (newPage) => {
        const resp = await getMdvrsDispositivos(newPage, palabra, cliente);
        if (resp.ok) {
            setDispositivosMdvrs(resp?.data);
            setPaginado((prev) => ({
                ...prev,
                page: newPage,
                previousPage: newPage > 1 ? newPage - 1 : null,
                nextPage: newPage < prev.totalPaginas ? newPage + 1 : null,
            }));
        }
    };

    const buscarDispositivos = async (pagina = 1) => {
        const resp = await getMdvrsDispositivos(
            pagina,
            palabra,
            cliente
        );

        if (resp.ok && resp.data) {
            setDispositivosMdvrs(resp.data);
            setPaginado({
                page: resp.data.paginacion.pagina,
                limit: resp.data.paginacion.totalRegistros,
                previousPage: resp.data.paginacion.previousPage,
                nextPage: resp.data.paginacion.nextPage,
                total: resp.data.paginacion.totalRegistros,
                totalPaginas: resp.data.paginacion.totalPaginas,
            });
        } else if (!resp.ok) {
            setDispositivosMdvrs([]);
            setPaginado({
                page: 1,
                limit: 0,
                previousPage: null,
                nextPage: null,
                total: 0,
                totalPaginas: 0,
            });
            return;
        }
    };

    const abrirDetalleMdvr = async (mdvr) => {
        if (loadingMdvr) return; // ⛔ evita doble click
        setForm(initialStateForm);
        setLoadingMdvr(true);

        try {
            setMdvrSeleccionado(mdvr);

            const res = await getInfoMdvr(mdvr.mdvr_id);

            if (res.ok && res.respuesta) {
                setInfoMdvrSeleccionado(res.respuesta);

                if (res.respuesta.ultima_revision) {
                    let { encendida, cam1, cam2, cam3, cam4, gps, grabacion, observaciones } = res?.respuesta?.ultima_revision;

                    setForm({
                        ...form,
                        estatus_equipo: encendida ? "encendido" : "apagado",
                        camara1: cam1?.estatus_dispositivo_id,
                        camara2: cam2?.estatus_dispositivo_id,
                        camara3: cam3?.estatus_dispositivo_id,
                        camara4: cam4?.estatus_dispositivo_id,
                        gps: !!gps,
                        grabacion: !!grabacion,
                        observaciones: observaciones || "",
                    });
                }

                const offcanvas = new bootstrap.Offcanvas(
                    document.getElementById("offcanvasRightComponent")
                );
                offcanvas.show();
            } else {
                Swal.fire({
                    icon: "info",
                    title: "Sin seguimiento",
                    text: "Este equipo no cuenta con información de seguimiento",
                    timer: 2500,
                    showConfirmButton: false,
                });
            }
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Ocurrió un error al obtener la información",
            });
        } finally {
            setLoadingMdvr(false); // ✅ SIEMPRE se ejecuta
        }
    };

    const handleSubmit = async () => {

        // if (!form.fecha_revicion) {
        //     Swal.fire("Error", "Selecciona fecha y hora", "warning");
        //     return;
        // }

        if (form.estatus_equipo === "encendido") {
            if (!form.camara1 || !form.camara2 || !form.camara3) {
                Swal.fire(
                    "Campos incompletos",
                    "Selecciona el estatus de todas las cámaras",
                    "warning"
                );
                return;
            }

            if (!form.imagen) {
                Swal.fire(
                    "Imagen requerida",
                    "Debes subir una imagen como evidencia",
                    "warning"
                );
                return;
            }

            if (!form.gps || !form.grabacion) {
                Swal.fire(
                    "Validación",
                    "Debes confirmar GPS y Grabación",
                    "warning"
                );
                return;
            }

        }

        if (!mdvrSeleccionado?.mdvr_id) {
            Swal.fire("Error", "No se encontró el MDVR", "error");
            return;
        }

        // ✅ Envío seguro
        const body = {
            mdvr_id: mdvrSeleccionado.mdvr_id,
            state: form.estatus_equipo === "encendido",
            cam1: Number(form.camara1),
            cam2: Number(form.camara2),
            cam3: Number(form.camara3),
            cam4: Number(form.camara4),
            gps: form.gps,
            grabacion: form.grabacion,
            observaciones: form.observaciones,
        };

        const resp = await postCheckListMdvr(body);

        if (resp.ok) {
            Swal.fire("Éxito", "Checklist guardado correctamente", "success");
            let formData = new FormData();
            formData.append('archivo', form.imagen);
            let cargaImg = await postImagenMdvr(resp?.resultado?.check_id, formData);
            if (cargaImg.ok) {
                console.log("imagen cargada correctamente: ", cargaImg.msg);
            } else {
                Swal.fire("Error", cargaImg.msg || "No se pudo guardar", "error");
            }
            closeOffcanvas();
        } else {
            Swal.fire("Error", resp.msg || "No se pudo guardar", "error");
            closeOffcanvas();
        }


    };

    const closeOffcanvas = () => {
        const element = document.getElementById("offcanvasRightComponent");
        const offcanvas = Offcanvas.getInstance(element);
        offcanvas?.hide();
    };

    /**
     * Procesa y valida un archivo de imagen antes de guardarlo en el formulario.
     * Se encarga de:
     *  - Validar que exista el archivo
     *  - Validar el tipo de archivo permitido
     *  - Validar el tamaño máximo
     *  - Guardar la imagen en el estado del formulario
     *
     * @param {File} file - Archivo de imagen obtenido desde input
     */
    const procesarArchivo = (file) => {
        // Si no hay archivo, no hace nada
        if (!file) return;

        // Validación del tipo de archivo
        if (!TIPOS_PERMITIDOS.includes(file.type)) {
            Swal.fire("Archivo inválido", "Solo imágenes permitidas", "warning");
            return;
        }

        // Validación del tamaño máximo permitido
        if (file.size > MAX_SIZE) {
            Swal.fire("Imagen muy grande", "Máximo 8MB", "warning");
            return;
        }
        // Si pasa todas las validaciones, se guarda la imagen en el estado
        setForm(prev => ({ ...prev, imagen: file }));
    };

    /**
     * Maneja el evento de pegar (Ctrl + V).
     * Permite capturar imágenes directamente desde el portapapeles.
     *
     * @param {ClipboardEvent} e - Evento de pegado
     */
    const handlePaste = (e) => {
        // Obtiene los elementos del portapapeles
        const items = e.clipboardData?.items;
        if (!items) return;

        // Recorre los elementos buscando una imagen
        for (let item of items) {
            if (item.type.startsWith("image")) {
                const file = item.getAsFile();
                // Procesa la imagen pegada
                procesarArchivo(file);
                // Evita que el navegador pegue la imagen como texto/base64
                e.preventDefault();
                break;
            }
        }
    };

    /**
     * Maneja el evento de soltar archivos (drag & drop).
     * Permite arrastrar una imagen desde el explorador de archivos.
     *
     * @param {DragEvent} e - Evento de drop
     */
    const handleDrop = (e) => {
        // Previene el comportamiento por defecto del navegador
        e.preventDefault();
        // Obtiene el primer archivo arrastrado
        const file = e.dataTransfer.files[0];
        // Procesa el archivo
        procesarArchivo(file);
    };

    /**
     * Maneja el evento dragOver.
     * Es necesario para permitir que el evento drop funcione correctamente.
     *
     * @param {DragEvent} e - Evento de arrastre
     */
    const handleDragOver = (e) => {
        // Evita que el navegador bloquee el drop
        e.preventDefault();
    };

    return (
        <>
            <div className="container mt-1 mb-4 fadeInDown animated delay-01s">
                {
                    clientesMdvrs?.length >= 1 && (
                        <div className="row">
                            <div className="col-6">
                                <Select
                                    options={clientesMdvrs?.map((x) => ({
                                        value: x.cliente,
                                        label: x.cliente,
                                    }))}
                                    className="form-control selectCedis mb-4"
                                    classNamePrefix="select"
                                    value={clienteSeleccionado}
                                    onChange={(opcion) => {
                                        setClienteSeleccionado(opcion);
                                        setCliente(opcion?.value || "");
                                    }}
                                    placeholder="Selecciona un cliente"
                                />

                            </div>
                            <div className="col-6 me-auto inputWithIcon">
                                <input
                                    className="form-control selectCedis"
                                    placeholder="BUSCAR UNIDAD"
                                    name="palabra"
                                    value={palabra}
                                    onChange={(e) => {
                                        const valor = e.target.value;
                                        setPalabra(valor);
                                    }}
                                ></input>
                                <button disabled={true}>
                                    <FontAwesomeIcon id="iconoBuscar" icon={faMagnifyingGlass} />
                                </button>
                            </div>
                        </div>
                    )
                }
                <TituloUnidadesConteo
                    longitud={dispositivosMdvrs?.paginacion?.totalRegistros && dispositivosMdvrs?.paginacion?.totalRegistros}
                ></TituloUnidadesConteo>
                <div className="row">
                    <div className="col-12">
                        <SinUnidades longitud={dispositivosMdvrs?.paginacion?.totalRegistros}></SinUnidades>
                        {
                            dispositivosMdvrs?.dispositivos?.length == 0 ? (
                                <>
                                    <div className="row justify-content-center">
                                        <h6>Sin unidades</h6>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div>
                                        {
                                            dispositivosMdvrs?.dispositivos?.map((x) => {
                                                return (
                                                    <>
                                                        <div
                                                            className="row unidad-element animated delay-01s my-3"
                                                            aria-controls="offcanvasRight"
                                                            onClick={() => abrirDetalleMdvr(x)}
                                                        >
                                                            <div
                                                                className="col-md-2 text-center pb-1 bordersLeftRounded"
                                                                style={{ background: "rgb(245, 245, 245)" }}
                                                            >
                                                                <div className="pt-1">
                                                                    <img
                                                                        src={mdvr}
                                                                        alt="imagen"
                                                                        className="img-fluid"
                                                                        style={{ inlineSize: "55px", maxWidth: "45%" }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-11 col-sm-9" style={{ margin: "auto" }}>
                                                                <div className="row">
                                                                    <div className="col-7">
                                                                        <h6>
                                                                            <small>UNIDAD: </small>
                                                                            <b>{x.mdvr_numero} </b>
                                                                        </h6>
                                                                    </div>
                                                                    <div className="col-5">
                                                                        <h6>
                                                                            <small>FLOTILLA: </small>
                                                                            <b>{x.flotilla} </b>
                                                                        </h6>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                            })
                                        }
                                    </div>
                                    <div className="position-relative">
                                        <Paginacion paginado={paginado} onPageChange={handlePageChange} />
                                    </div>
                                </>
                            )
                        }
                    </div>
                </div>
            </div>
            <ModalFormRight
                id="offcanvasRightComponent"
                title={`MDVR ${infoMdvrSeleccionado && infoMdvrSeleccionado?.dispositivo?.mdvr_numero}`}
                data={infoMdvrSeleccionado}
            >
                {
                    infoMdvrSeleccionado && (
                        <>
                            <div className="form-group col-12 flex-column d-flex mb-2">
                                <label><strong>ID EQUIPO:</strong>  {infoMdvrSeleccionado?.dispositivo?.id_equipo}</label>
                            </div>
                            <div className="form-group col-12 flex-column d-flex mb-2">
                                <label><strong>CLIENTE:</strong> {infoMdvrSeleccionado?.dispositivo?.cliente}</label>
                            </div>
                            <div className="form-group col-12 flex-column d-flex mb-2">
                                <label><strong>FLOTILLA:</strong> {infoMdvrSeleccionado?.dispositivo?.flotilla}</label>
                            </div>
                            <div className="form-group col-12 flex-column d-flex mb-2">
                                <label><strong>Estatus del equipo:</strong></label>
                                <select
                                    className="form-select mt-2"
                                    value={form.estatus_equipo}
                                    onChange={(e) => setForm({ ...form, estatus_equipo: e.target.value })}
                                    required
                                >
                                    <option value="">
                                        Selecciona una opción
                                    </option>
                                    <option value="encendido">Encendido</option>
                                    <option value="apagado">Apagado</option>
                                </select>
                            </div>
                            {/* <div className="form-group col-12 flex-column d-flex mb-2">
                                <label><strong>Fecha y hora de revisión:</strong></label>
                                <input
                                    type="datetime-local"
                                    className="form-control mt-2"
                                    value={form.fecha_revicion}
                                    onChange={(e) => setForm({ ...form, fecha_revicion: e.target.value })}
                                    required
                                />
                            </div> */}

                            {
                                form.estatus_equipo === "encendido" && (
                                    <>
                                        <div className="form-group col-12 d-flex gap-4 mb-2">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="gps"
                                                    checked={form.gps}
                                                    onChange={(e) =>
                                                        setForm({ ...form, gps: e.target.checked })
                                                    }
                                                />
                                                <label className="form-check-label" htmlFor="gps">
                                                    GPS
                                                </label>
                                            </div>
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="grabacion"
                                                    checked={form.grabacion}
                                                    onChange={(e) =>
                                                        setForm({ ...form, grabacion: e.target.checked })
                                                    }
                                                />
                                                <label className="form-check-label" htmlFor="grabacion">
                                                    Grabación
                                                </label>
                                            </div>
                                        </div>
                                        <div className="form-group col-12 d-flex align-items-center mb-2">
                                            <label className="me-2"><strong>Camara 1</strong></label>
                                            <select
                                                style={{ maxWidth: "70%" }}
                                                className="form-select mt-2"
                                                value={form.camara1}
                                                onChange={(e) => setForm({ ...form, camara1: e.target.value })}
                                            // disabled={}
                                            // required={required}
                                            >
                                                <option value="">
                                                    Selecciona una opción
                                                </option>
                                                {statusCamaras.map((option) => {
                                                    return (
                                                        <option value={option.estatus_dispositivo_id} key={option.estatus_dispositivo_id}>
                                                            {option.estatus_dispositivo}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                        <div className="form-group col-12 d-flex align-items-center mb-2">
                                            <label className="me-2"><strong>Camara 2</strong></label>
                                            <select
                                                style={{ maxWidth: "70%" }}
                                                className="form-select mt-2"
                                                value={form.camara2}
                                                onChange={(e) => setForm({ ...form, camara2: e.target.value })}
                                            // disabled={}
                                            // required={required}
                                            >
                                                <option value="">
                                                    Selecciona una opción
                                                </option>
                                                {statusCamaras.map((option) => {
                                                    return (
                                                        <option value={option.estatus_dispositivo_id} key={option.estatus_dispositivo_id}>
                                                            {option.estatus_dispositivo}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                        <div className="form-group col-12 d-flex align-items-center mb-2">
                                            <label className="me-2"><strong>Camara 3</strong></label>
                                            <select
                                                style={{ maxWidth: "70%" }}
                                                className="form-select mt-2"
                                                value={form.camara3}
                                                onChange={(e) => setForm({ ...form, camara3: e.target.value })}
                                            // disabled={}
                                            // required={required}
                                            >
                                                <option value="">
                                                    Selecciona una opción
                                                </option>
                                                {statusCamaras.map((option) => {
                                                    return (
                                                        <option value={option.estatus_dispositivo_id} key={option.estatus_dispositivo_id}>
                                                            {option.estatus_dispositivo}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                        <div className="form-group col-12 d-flex align-items-center mb-2">
                                            <label className="me-2"><strong>Camara 4</strong></label>
                                            <select
                                                style={{ maxWidth: "70%" }}
                                                className="form-select mt-2"
                                                value={form.camara4}
                                                onChange={(e) => setForm({ ...form, camara4: e.target.value })}
                                            // disabled={}
                                            // required={required}
                                            >
                                                <option value="">
                                                    Selecciona una opción
                                                </option>
                                                {statusCamaras.map((option) => {
                                                    return (
                                                        <option value={option.estatus_dispositivo_id} key={option.estatus_dispositivo_id}>
                                                            {option.estatus_dispositivo}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                        <div className="form-group col-12 flex-column d-flex mb-2">
                                            <label><strong>Observaciones:</strong></label>
                                            <textarea
                                                className="form-control mt-2"
                                                rows={3}
                                                value={form.observaciones}
                                                onChange={(e) =>
                                                    setForm({ ...form, observaciones: e.target.value })
                                                }
                                                placeholder="Escribe observaciones del equipo..."
                                            />

                                        </div>
                                    </>
                                )
                            }
                            <div className="form-group col-12 flex-column d-flex mb-2">
                                <label><strong>Evidencia (imagen):</strong></label>

                                <div
                                    className="border border-2 border-dashed rounded p-4 text-center bg-light"
                                    style={{ cursor: "pointer", background: "#f8f9fa" }}
                                    onPaste={handlePaste}
                                    onDrop={handleDrop}
                                    onDragOver={handleDragOver}
                                >
                                    <p className="mb-1 text-secondary">
                                        <span className="d-flex align-items-center justify-content-center gap-2 fw-bold">
                                            📋 Pega una imagen <small className="fw-normal">(Ctrl + V)</small>
                                        </span>

                                        <span className="d-block my-1 text-center">
                                            🖱️ <strong>Arrastra y suelta aquí</strong>
                                        </span>

                                        <span className="d-block text-center text-muted fst-italic">
                                            📁 o selecciona un archivo
                                        </span>
                                    </p>

                                    <input
                                        type="file"
                                        className="form-control mt-2"
                                        accept="image/jpg,image/jpeg,image/jpge,image/png,image/gif,image/bmp,image/tiff"
                                        onChange={(e) => procesarArchivo(e.target.files[0])}
                                    />
                                </div>
                            </div>
                            {form.imagen && (
                                <div className="form-group col-12 mb-2 text-center">
                                    <img
                                        src={URL.createObjectURL(form.imagen)}
                                        alt="Vista previa"
                                        style={{ maxWidth: "100%", maxHeight: "200px" }}
                                        className="img-thumbnail"
                                    />
                                </div>
                            )}
                            <div className="form-group col-12 flex-column d-flex mb-2">
                                <button className="btn btn-primary mt-3" onClick={handleSubmit}>
                                    {
                                        infoMdvrSeleccionado?.ultima_revision ? (
                                            <>
                                                Actualizar
                                            </>
                                        ) : (
                                            <>
                                                Registrar
                                            </>
                                        )
                                    }
                                </button>
                            </div>
                        </>
                    )
                }
            </ModalFormRight>
        </>
    )
}